import React from "react";
import Button from "@mui/material/Button";
import Snackbar from "@mui/material/Snackbar";
import Alert from "@mui/material/Alert";

export default function AlertComponent({
  open,
  setOpen,
  type,
  message,
  reset,
  position,
}) {
  const handleClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    if (reset) {
      reset();
    }

    setOpen(false);
  };

  return (
    <div>
      <Snackbar
        anchorOrigin={
          position
            ? { vertical: position.vertical, horizontal: position.horizontal }
            : { vertical: "bottom", horizontal: "right" }
        }
        open={open}
        autoHideDuration={6000}
        onClose={handleClose}
      >
        <Alert
          onClose={handleClose}
          severity={type}
          variant="filled"
          sx={{ width: "100%" }}
        >
          {message}
        </Alert>
      </Snackbar>
    </div>
  );
}
